import getEmojiMru from 'owa-expressions-store/lib/utils/getEmojiMru';
import {
    EmojiContextualSearchViewState,
    MAX_CONTEXTUAL_EMOJI_LENGTH,
} from '../store/schema/EmojiContextualSearchViewState';

export default function createEmojiContextualSearchViewState(): EmojiContextualSearchViewState {
    return {
        wordBeforeCursor: '',
        emojis: getEmojiMru(MAX_CONTEXTUAL_EMOJI_LENGTH - 1),
        isSuggesting: false,
        isPopupShown: false,
        isShortcut: false,
        selectedEmojiIndex: 0,
        showMore: true,
    };
}
